import React, { useState } from 'react'
// import { ProgressSpinner } from 'primereact/progressspinner'
import './misc.scss'

const LoadingCircle = (props: {
    active: boolean
    backdrop?: boolean
    size?: number
    color?: string
}) => {
    const { active, backdrop, size, color } = props
    return (
        <>
            {active && (
                <div
                    className={
                        backdrop
                            ? 'wardrobe-backdrop'
                            : 'wardrobe-spinner-container'
                    }>
                    <i
                        className="cu cu-loading loading-spinner-icon"
                        style={{
                            width: size ? size + 'px' : 'var(--spacing-5)',
                            height: size ? size + 'px' : 'var(--spacing-5)',
                            fontSize: size ? size + 'px' : 'var(--spacing-5)',
                            color: `var(--lux-${color ? color : 'white'})`,
                        }}
                    />
                    {/* <ProgressSpinner
                        className="wardrobe-spinner"
                        style={{ width: '75px', height: '75px' }}
                        strokeWidth="5"
                        animationDuration=".6s"
                    /> */}
                </div>
            )}
        </>
    )
}

export default LoadingCircle
